// extracted by mini-css-extract-plugin
export default {"headline":"homeHeader_headline__xH14K"};